<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-card max-width="75%" flat color="background">
        <v-row class="d-flex">
          <h1 class="mb-4">Sigue tu servicio</h1>
        </v-row>

        <MapTracingVue />

        <v-row align="center" justify="center">
          <v-col>
            <v-row class="d-flex align-center justify-start mt-4">
              <p>Hora máxima de llegada:</p>
            </v-row>
          </v-col>
          <v-col>
            <v-row class="d-flex align-center justify-end">
              <h1>{{ servicioData.deliveryTime.slice(0, 5) }} hrs</h1>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="mb-6" align="center" justify="center">
          <v-progress-linear
            color="secondary"
            height="10"
            rounded
            :value="progesoData.percentage"
          ></v-progress-linear>
        </v-row>

        <!-- <v-row class="d-flex align-center justify-start mt-4">
          <p>
            <b>Llegando a:</b>
            Irolo 87 Zacahuitzco, Benito Juarez, CDMX, 03550 Interior 101
            Edificio de cemento negro, con puerta de cristal y portón de madera.
          </p>
        </v-row> -->

        <v-row class="d-flex">
          <h2 class="mb-4">Tu repartidor</h2>
        </v-row>

        <v-row align="center" justify="center">
          <v-col>
            <v-row align="center" justify="center">
              <v-avatar size="80">
                <img :src="servicioData.provider.urlPhoto" />
              </v-avatar>
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="start">
              <h3>{{ servicioData.provider.shortName }}</h3>
            </v-row>
            <v-row align="center" justify="start">
              <p><b>Asistente:</b> {{ servicioData.provider.assistantName }}</p>
            </v-row>
            <v-row align="center" justify="start">
              <p><b>Compañía:</b> {{ servicioData.provider.company.name }}</p>
            </v-row>
            <v-row align="center" justify="start">
              <p>
                <b>Precio:</b> ${{
                  servicioData.provider.company.pricePerLiter
                }}
                Litro
              </p>
            </v-row>
          </v-col>
          <!-- <v-col>
            <v-row align="center" justify="center">
              <v-btn outlined>Llamar</v-btn>
            </v-row>
          </v-col> -->
        </v-row>

        <!-- <v-row align="center" justify="center">
          <v-btn color="primary" class="mb-6" text>Cancelar mi servicio</v-btn>
        </v-row> -->

        <!-- <v-row align="center" justify="center">
          <v-btn color="primary" class="mb-6" rounded @click="toQualify()"
            >Calificar mi servicio</v-btn
          >
        </v-row> -->
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import Axios from "axios";
import { mapFields } from "vuex-map-fields";
import config from "../config"
import MapTracingVue from "../components/MapTracing.vue";

export default {
  computed: {
    ...mapFields([
      "seguirServicioNumberUuid",
      "coordenadasSigueServicio",
      "loader",
    ]),
  },
  data() {
    return {
      servicioData: {
        deliveryTime: "17:00:00",
      },
      progesoData: {},
    };
  },
  components: {
    MapTracingVue,
  },
  methods: {
    // toQualify() {
    //   this.$router.push({ name: "Qualify" });
    // },
    async getData() {
      this.loader = true;
      let api = Axios.get(
        config.apiBaseUrl + "/services/detail-customer/" + this.seguirServicioNumberUuid,
        {
          headers: {
            "x-api-key": config.apiKey,
          },
        }
      )
        .then((response) => {
          this.servicioData = response.data;
          return Axios.get(
            config.apiBaseUrl +
              "/services/customer/progress/" +
              this.seguirServicioNumberUuid,
            {
              headers: {
                "x-api-key": config.apiKey,
              },
            }
          );
        })
        .then((response) => {
          this.progesoData = response.data;
          this.getCoordenadas(response.data);
          this.loader = false;
        })
        .catch((error) => {
          console.error(error);
          this.loader = false;
          // this.$router.push({ name: "Home" });
        });
    },
    getCoordenadas(data) {
      this.coordenadasSigueServicio.coordenadasServicio.lat = parseInt(
        data.serviceCoordinates.latitude
      );
      this.coordenadasSigueServicio.coordenadasServicio.lng = parseInt(
        data.serviceCoordinates.longitude
      );

      this.coordenadasSigueServicio.coordenadasProveedor.lat = parseInt(
        data.providerCoordinates.latitude
      );
      this.coordenadasSigueServicio.coordenadasProveedor.lng = parseInt(
        data.providerCoordinates.longitude
      );
    },
  },
  mounted() {
    if (this.seguirServicioNumberUuid) {
      this.getData();
    } else {
      this.$router.push({ name: "Home" });
    }
  },
};
</script>

<style>
</style>